import MyAsset from "../../asset_strings";

export default function Showcase() {
  return (
    <div className="w-full h-screen flex flex-col justify-center items-center">
      <img
        className="w-full h-full object-cover"
        src={window.innerWidth >= 768 ? MyAsset.BG_DESKTOP : MyAsset.BG_MOBILE}
        alt="Background"
      />
    </div>
  );
}
